<template>
  <div dir="rtl" class="modal fade forgetpassword-modal qbank-section" id="show-report-modal" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" @show.modal="hidePaymentModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            قائمة بكل البلاغات
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body">
          <div class="support-box text-center">
            <img class="icon-img text-center" src="assets/img/exclamation.png" alt="" />
          </div>
          <h4 class="mb-3 text-center support-text">
            <div class="mb-2">بلاغات الإختبار</div>
          </h4>
          <input type="hidden" id="qbankReportId">

          <div class="reports-container">
            <div v-if="isLoading" class="text-center py-4">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">جاري التحميل...</span>
              </div>
              <div class="mt-2">جاري تحميل البلاغات...</div>
            </div>

            <div v-else-if="qbankReports.length === 0" class="text-center text-muted py-4">
              لا توجد بلاغات متاحة حاليًا.
            </div>

            <div v-else>
              <div v-for="report in qbankReports" :key="report.id" class="card report-card mb-3">
                <div class="card-body">
                  <h5 class="report-title mb-1">العنوان: {{ report.title }}</h5>
                  <p class="report-content mb-1">المحتوى: {{ report.content }}</p>
                  <p class="report-question mb-1">السؤال: {{ report.question.content }}</p>
                  <small class="text-muted">تاريخ الإنشاء: {{ new Date(report.created_at).toLocaleString() }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";

export default {
  name: "Reports",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      isLoading: false,
      qbankReports: [],
    };
  },

  methods: {
    async showReports() {
      this.isLoading = true;
      this.qbankReports = [];

      let qbankReportId = document.getElementById("qbankReportId").value;

      try {
        const response = await fetch(
          `${apiUrl}/qbanks/${qbankReportId}/reports`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          this.qbankReports = data.data;
        } else {
          console.error("Failed to fetch reports");
        }
      } catch (error) {
        console.error("Error fetching reports:", error);
      } finally {
        this.isLoading = false;
      }
    }
  },
};
</script>

<style scoped>
.icon-img {
  margin-bottom: 10px;
  width: 100px;
}

.reports-container {
  max-height: 300px;
  overflow-y: auto;
  padding: 5px;
}

.report-card {
  border-right: 2px solid #000;
  border-left: 2px solid #000;
  background-color: #f8f9fa12;
  font-weight: 700;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.report-content {
  word-wrap: break-word;
  white-space: pre-wrap;
  font-size: 14px;
}
</style>
